<div class="row">
  <app-navbar></app-navbar>
</div>
<div class="row">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>